const ResetModal = function () {
  //this.addItem.modal.hide()
  this.addItem.resetForm()
}

export default ResetModal
